module.exports = __webpack_public_path__ + "static/assets/5bd2580fa163156677ba580d93efad6c.svg";